import { Button, Center, Divider, HStack, Heading, Switch, VStack } from '@chakra-ui/react';
import { useAtom } from 'jotai';

import { useRunAutoStructureCronsMutation } from '../../../gql/generated/graphql';
import { allowDuplicateVinAtom } from '../../dashboard/components/devToolbarAtoms';
import useGetRandomDevVin from '../../dashboard/components/useGetRandomDevVin';

const FlowEntryDevToolbar = () => {
  const [allowDuplicateVin, setAllowDuplicateVin] = useAtom(allowDuplicateVinAtom);

  const [runAutoStructureCrons, { loading: runningCrons }] = useRunAutoStructureCronsMutation({
    onCompleted: () => {
      window.location.reload();
    },
  });

  const [getProdRandomVin, { loading: gettingRandomVin }] = useGetRandomDevVin();

  return (
    <Center>
      <VStack
        align="left"
        borderWidth={2}
        borderColor="grayBlueish"
        borderRadius="lg"
        my="10px"
        p="10px"
        w="300px"
      >
        <Heading textAlign="center">Dev Tools</Heading>
        <HStack>
          <Switch
            isChecked={allowDuplicateVin}
            onChange={(e) => setAllowDuplicateVin(e.target.checked)}
          >
            Allow duplicate vin
          </Switch>
        </HStack>
        <Divider my="10px" />
        <Button
          fontWeight="semibold"
          size="sm"
          fontSize="sm"
          onClick={() => runAutoStructureCrons()}
          isLoading={runningCrons}
          loadingText="Running Auto Structure Crons..."
        >
          Run Auto Structure Crons
        </Button>
        <Button
          fontWeight="semibold"
          size="sm"
          fontSize="sm"
          onClick={() => getProdRandomVin()}
          isLoading={gettingRandomVin}
        >
          Get Random VIN
        </Button>
      </VStack>
    </Center>
  );
};

export default FlowEntryDevToolbar;
